// @flow
import * as React from 'react';

export type hoverHandlersType = {
  onMouseOver: () => void,
  onMouseLeave: () => void,
};

type Props = {
  hoverHandlers: hoverHandlersType,
  isHovering: boolean,
};

type State = {
  isHovering: boolean,
};

const HOVER_DELAY = 32;
const SCROLL_DELAY = 100;

let scrollTimer: ?TimeoutID = null;

let isScrolling = false;

const allInstances = [];

const setScroll = () => {
  if (scrollTimer) {
    clearTimeout(scrollTimer);
  }
  isScrolling = true;
  scrollTimer = setTimeout(() => {
    isScrolling = false;
  }, SCROLL_DELAY);
};

const attachScrollListener = (instance) => {
  if (allInstances.length === 0) {
    window.addEventListener('scroll', setScroll);
  }
  allInstances.push(instance);
};

const detachScrollListener = (instance) => {
  const instanceIdx = allInstances.indexOf(instance);
  allInstances.splice(instanceIdx, 1);
  if (allInstances.length === 0) {
    window.removeEventListener('scroll', setScroll);
  }
};

export default function hoverable<InputProps: {}>(
  Subject: React.ComponentType<{ ...InputProps, ...Props }>,
) {
  return class Hoverable extends React.Component<InputProps, State> {
    state: State = {
      isHovering: false,
    };

    componentDidMount() {
      attachScrollListener(this);
    }

    componentWillUnmount() {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      detachScrollListener(this);
    }

    hoverTimer: ?TimeoutID;

    _setHover(isHovering: boolean) {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      if (isHovering && isScrolling) {
        this.hoverTimer = setTimeout(() => this._setHover(isHovering), SCROLL_DELAY);
        return;
      }
      this.hoverTimer = setTimeout(() => {
        if (isHovering === this.state.isHovering) {
          return;
        }
        this.setState({ isHovering });
      }, HOVER_DELAY);
    }

    handlers: hoverHandlersType = {
      onMouseOver: () => this._setHover(true),
      onMouseLeave: () => this._setHover(false),
    };

    render() {
      return (
        <Subject {...this.props} hoverHandlers={this.handlers} isHovering={this.state.isHovering} />
      );
    }
  };
}
